module.exports = __webpack_public_path__ + "static/media/MC.dfa32ae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/MC.jpg
// module id = 1428
// module chunks = 0